export default function DropDownIcon({ rotate = 0, color }) {
  return (
    <>
      <svg
        width="13"
        height="6"
        viewBox="0 0 13 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ transform: `rotate(${rotate}deg)` }}
      >
        <path
          d="M6.5 5.82617L0.00480981 0.0870421L12.9952 0.087041L6.5 5.82617Z"
          fill={color || "#6B6B6B"}
        />
      </svg>
    </>
  )
}
